<template>
  <b-modal
    ok-title="Exportar"
    cancel-title="Cancelar"
    @ok="submit"
    title="Exportar CSV de Presenças"
    :id="id"
  >
    <b-form-group label="Datas">
      <b-form-tags
        input-id="dates-input"
        placeholder="YYYY-MM-DD"
        v-model="dates"
        separator=" ,;"
        remove-on-delete
    /></b-form-group>
    <b-form-group
      label="Tempo minimo que usuário esteve presencial (em minutos)"
    >
      <b-form-input v-model="minTimeMinutes" type="number" />
    </b-form-group>
    <b-form-group label="Filtro">
      <b-form-select v-model="filter" :options="options"
    /></b-form-group>
  </b-modal>
</template>

<script>
import { exportarCSVPresencas } from "../../../services/api/Presenca";
import FileHelper from "../../../utils/FileHelper";
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dates: [],
      minTimeMinutes: 0,
      filter: "both",
      options: [
        { value: "both", text: "Presencial e Online" },
        { value: "online", text: "Apenas online" },
        { value: "presential", text: "Apenas presencial" },
      ],
    };
  },
  methods: {
    async submit() {
      try {
        const { data } = await exportarCSVPresencas(
          this.dates,
          this.minTimeMinutes,
          this.filter
        );
        FileHelper.salvarArquivo(data.csv, data.mimeType, data.fileName);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.message, {
          title: "Erro",
          variant: "danger",
          autoHideDelay: 5000,
        });
      }
    },
  },
};
</script>
